import React from 'react';

interface InterviewHeaderProps {
  icon?: React.ReactNode;
}

const InterviewHeader: React.FC<InterviewHeaderProps> = ({ icon }) => (
  <div className="relative w-full h-[120px]" style={{ overflow: 'visible', flexShrink: 0 }}>
    <img
      src="/images/adic-interview-background.png"
      alt="Interview background"
      className="w-full h-full object-cover"
    />
    <img
      src="/images/mic-logo.png"
      alt="MIC Logo"
      width={136}
      height={64}
      className="absolute top-6 left-6"
    />
    {icon && (
      <div
        style={{
          position: 'absolute',
          bottom: '-20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
        }}
      >
        {icon}
      </div>
    )}
  </div>
);

const SimpleBannerHeader: React.FC = () => (
  <img
    src="/images/dialogue-banner.png"
    alt="Dialog Banner"
    style={{
      width: '100%',
      display: 'block',
      flexShrink: 0,
    }}
  />
);

interface DialogHeaderProps {
  variant: 'interview' | 'simple';
  icon?: React.ReactNode;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({
  variant,
  icon,
}) => {
  if (variant === 'interview') {
    return <InterviewHeader icon={icon} />;
  }
  return <SimpleBannerHeader />;
};
